import { useEffect, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import {
  Table,
  TableBody,
  TableBuildingTag,
  TableCard,
  TableCell,
  TableDepartmentTag,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import { Link } from "react-router";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import StatusChip from "../../../../component/ui/chip/status";
import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";
import FuleInvPopup from "../popup";
import { BillReceipt, Date2Icon, Date3Icon, DateIcon, LocationIcon, NoteIcon, StatusIcon, TankerIcon, VendorIcon } from "../../../../component/icons/filter-icons";

const WaterTankerList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [addModal, setAddModal] = useState(false);
  const [dropdowns, setDropdowns] = useState({});
  const [tabIndex, setTabIndex] = useState(null);

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getDropdowns()
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-water-tanker-entry-list${extraUrl}`,
      });
      if (page) {
        setList((prev) => [...prev, ...res.data]);
      } else {
        setList(res.data);
      }

      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getDropdowns = async () => {
    try {
      let apiRes = await apiCall({ method: "get", url: "get-water-tanker-dropdown-list?type=building,vendor" })
      setDropdowns(apiRes?.data)
    } catch (error) {
      console.log("Error", error)
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setCurrentData({});
    setAddModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const filterModalData = [
    {
      name: "location_id",
      label: "Location",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: dropdowns?.building,
      dropdownKey: "name",
      dropdownVal: "id",
      Icon: LocationIcon
    },
    {
      name: "vendor_id",
      label: "Vendor",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: dropdowns?.vendor,
      dropdownKey: "full_name",
      dropdownVal: "id",
      Icon: VendorIcon
    },
    {
      name: "bill_receipt_number",
      label: "Bill Receipt Number",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: BillReceipt
    },
    {
      name: "notes",
      label: "Notes",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: NoteIcon
    },
    {
      name: "created_at",
      label: "Created Date",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "date",
      type: "date",
      Icon: Date2Icon
    },
    {
      name: "billed_at",
      label: "Billed Date",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "date",
      type: "date",
      Icon: DateIcon
    },
    {
      name: "paid_at",
      label: "Paid Date",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "date",
      type: "date",
      Icon: Date3Icon
    },
    {
      name: "tanker_no",
      label: "Tanker Number",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
      Icon: TankerIcon
    },
    {
      name: "status",
      label: "Status",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [{label: "pending", value: "pending"}, {label: "billed", value: "billed"}, {label: "paid", value: "paid"}],
      dropdownKey: "label",
      dropdownVal: "value",
      Icon: StatusIcon
    }
  ];
  const [selectFilterName, setSelectFilterName] = useState('My Filter')
  const [editingFilters, setEditingFilters] = useState(null)

  const editDetail = (ele) => {
    setTabIndex(0);
    setCurrentData(ele);
    setAddModal(true);
  };

  return (
    <>
      <div className={Style.leaveMainPage}>
        <TableFilterReturn
          filterReturn={filterReturn}
          onChange={(filters) => {
            setFilterReturn(filters);
            getData({ filters });
          }}
        />
        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Water Usage Records`} />
          </span>

          <div className={Style.bpfl_action}>
            <div
              className={Style.bpfl_action}
              onClick={() => { setAddModal(true) }}
            >
              <Tooltip
                content={"Add Data"}
                position={"left center"}
                className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
              >
                <div className={Style.icon}>
                  <PlusIcon size={'1em'} />
                </div>
              </Tooltip>
            </div>
            <Tooltip
              className={Style.bpfl_actionItems}
              content={"Table Filter"}
              position={"left center"}
            >
              <div
                className={`${Style.bpfl_actionBtn} ${filterReturn?.length ? Style.active : null
                  }`}
                onClick={() => {
                  setShowModalFilterTable(true);
                }}
              >
                <div className={Style.icon}>
                  <FilterFunnel01Icon />
                </div>
              </div>
            </Tooltip>
            <div className={`${Style.bpfl_action}`}>
              <Tooltip
                className={`${Style.bpfl_actionItems}`}
                content={"Customize Table"}
                position={"left center"}
              >
                <div
                  className={`${Style.bpfl_actionBtn}`}
                  onClick={() => {
                    setShowModalCustomizeTabs(true);
                  }}
                >
                  <div className={Style.icon}>
                    <LayoutTopIcon />
                  </div>
                </div>
              </Tooltip>
            </div>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {isLoading ? (
            <InnerLoader />
          ) : !lists?.length ? (
            <DataNotFound title={"Data"} />
          ) : (
            <>
              <TableCard>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell header sticky>
                        <div className="flex gap-4 items-center">
                          <span>Date</span>
                        </div>
                      </TableCell>
                      {tableHeaders?.map((eachHead, index) =>
                        eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                          <TableCell header key={index}>
                            <TableHeaderWrap>
                              <span>{eachHead?.value}</span>
                            </TableHeaderWrap>
                          </TableCell>
                        ) : null
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {lists?.map((eachList, index) => {
                      return (
                        <TableRow key={`${index}`}>
                          <TableCell sticky>
                            <div className={`${Style.tableActionArea} !gap-4`}>
                              <div className="flex gap-[10px]">
                                <div className="flex items-center gap-3">
                                  <div className="font-semibold text-[15px] leading-5">{eachList?.date}</div>
                                </div>
                              </div>

                              <div className={Style.tableActionAreaBtnGrpup}>
                                <div
                                  className={
                                    "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                  }
                                  onClick={() => {
                                    editDetail(eachList);
                                  }}
                                >
                                  <div
                                    className={Style.icon}
                                    style={{ color: "#FF9500" }}
                                  >
                                    <NewEditIcon className="h-4.5 w-4.5" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TableCell>

                          {tableHeaders?.map((eachHead, i) =>
                            eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                              <>
                                {eachHead.key === "status" ? (
                                  <TableCell
                                    key={`${i}-${index}`}
                                    className={`text-center`}
                                  >
                                    {eachList[eachHead?.key].toLowerCase() === "paid" ? (
                                      <StatusChip color="green">{eachList[eachHead?.key] || "--"}</StatusChip>
                                    ) : eachList[eachHead?.key].toLowerCase() === "billed" ? (
                                      <StatusChip color="red">{eachList[eachHead?.key] || "--"}</StatusChip>
                                    ) : eachList[eachHead?.key] === "Under Repair" ? (
                                      <StatusChip color="purple">{eachList[eachHead?.key] || "--"}</StatusChip>
                                    ) : (
                                      <StatusChip color="blue">{eachList[eachHead?.key] || "--"}</StatusChip>
                                    )}
                                  </TableCell>
                                ) : eachHead.key === "assigned_to_department" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <div className="flex flex-wrap gap-2 max-w-[550px]">
                                      {eachList?.assigned_to_department ? (
                                        eachList.assigned_to_department.split(",").map((dep, index) => (
                                          <TableDepartmentTag
                                            title={dep.trim()}
                                          />
                                        ))
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </TableCell>
                                ) : eachHead.key === "assigned_to_designation" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <div className="flex flex-wrap gap-2 max-w-[550px]">
                                      {eachList?.assigned_to_designation ? (
                                        eachList?.assigned_to_designation.split(",").map((des, index) => (
                                          <span>{des.trim()}</span>
                                        ))
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </TableCell>
                                ): eachHead.key === "location_name" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <div className="flex flex-wrap gap-2 max-w-[550px]">
                                      <TableBuildingTag title={eachList[eachHead?.key]} colorIndex={Number(eachList[eachHead?.key]?.replaceAll("B", ""))} />
                                    </div>
                                  </TableCell>
                                ) : eachHead.key === "created_by" ? (
                                  <TableCell key={`${i}-${index}`}>
                                    <AvatarProfile
                                      title={eachList?.created_by}
                                      src={eachList?.created_by_profile_picture?.split(",")[index]?.trim()}
                                    />
                                  </TableCell>
                                ) : (
                                  <TableCell key={`${i}-${index}`}>
                                    {(eachList[eachHead?.key]) ? (typeof eachList[eachHead?.key] == "string" && eachList[eachHead?.key]?.slice(0, 5) == "https") ? <Link to={eachList[eachHead?.key]} target="_blank" className="text-blue-600 underline">View</Link> : eachList[eachHead?.key] : "-"}
                                  </TableCell>
                                )}
                              </>
                            ) : null
                          )}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableCard>
            </>
          )}
        </div>

        {!isLoading ? (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              {`showing 1 to ${lists?.length} of ${tablePagination?.total || lists?.length
                }`}
            </div>

            {tablePagination ? (
              <div className={Style.empDirectory_footer}>
                {tablePagination?.next_page_url ? (
                  <button
                    className={Style.loadMoreBtn}
                    onClick={() => {
                      if (btnLoader) return;
                      // setPageCount(pageCount + 1);
                      setBtnLoader(true);
                      // filterData({ page: pageCount + 1, btnCall: true });
                      getData({ page: tablePagination?.next_page_url });
                    }}
                  >
                    {btnLoader ? (
                      <InnerLoader
                        className={Style.loader}
                        textStatus={false}
                      />
                    ) : (
                      "Load More"
                    )}
                  </button>
                ) : null}
              </div>
            ) : null}

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        ) : (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              <Skeleton width={"50%"} height={15} />
            </div>

            <div className={Style.empDirectory_footer}>
              <Skeleton width={"180px"} height={40} />
            </div>

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        )}
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters);
            setSelectFilterName(filterName);
            setEditingFilters(editingFilter);
            getData({ filter: filters });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
          saveFilter={saveFilter}
          apiUrl="get-water-tanker-entry-list"
        />
      )}

      {addModal &&
        // <AddPopup 
        //   currentData={currentData} 
        //   onClose={() => { setAddModal(false); setCurrentData({}) }} 
        //   onError={onError} 
        //   onSubmit={onSuccess} 
        //   dropdowns={dropdowns} 
        // />

        <FuleInvPopup
          currentData={currentData}
          onClose={() => { setAddModal(false); setCurrentData({}); setTabIndex(null); }}
          onError={onError}
          onSubmit={onSuccess}
          tabIndex={tabIndex}
          dropdowns={dropdowns}
        />
      }




      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => { setShowModalCustomizeTabs(false); }}
          onSave={(saveHeaders) => { setTableHeaders(saveHeaders); }}
          apiUrl="get-water-tanker-entry-list"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default WaterTankerList;
